import { DefaultEmailStyles } from '@wix/shoutout-email-model-v3';
import { elementMutatorFactory } from './element-mutator';
const colorMutatorFactory = (defaults) => elementMutatorFactory(($el) => {
    $el.css('color', $el.css('color') || defaults.color);
});
const textDecorationMutatorFactory = (defaults) => elementMutatorFactory(($el) => {
    $el.css('text-decoration', $el.css('text-decoration') || defaults.textDecoration);
});
export const linkStyleInjectorFactory = () => {
    const defaults = DefaultEmailStyles.a;
    return {
        elements: ['a'],
        mutators: [
            colorMutatorFactory(defaults),
            textDecorationMutatorFactory(defaults),
        ],
    };
};
//# sourceMappingURL=inject-missing-link-style.js.map